module.exports = __webpack_public_path__ + "img/zuodeihong.a7b0c439.jpg";